import { signOut } from 'aws-amplify/auth'

export default {
  methods: {
    signOut() {
      return signOut()
    },
  },
}
